/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArchiveCabinetIcon24Regular = forwardRef('ArchiveCabinetIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M9.25 7.75A.75.75 0 0 1 10 7h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75Z" }),
        React.createElement("path", { d: "M10 15.5a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5h-4Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 2.25A3.75 3.75 0 0 0 4.25 6v12A3.75 3.75 0 0 0 8 21.75h8A3.75 3.75 0 0 0 19.75 18V6A3.75 3.75 0 0 0 16 2.25H8Zm10.25 9V6A2.25 2.25 0 0 0 16 3.75H8A2.25 2.25 0 0 0 5.75 6v5.25h12.5Zm-12.5 1.5h12.5V18A2.25 2.25 0 0 1 16 20.25H8A2.25 2.25 0 0 1 5.75 18v-5.25Z" })));
});
